import React from 'react';
import { TextInput } from '@carbon/react';

const RecorderSettings: React.FC = () => (
  <>
    {/* <p className="settings-page__tab-copy">Define capture quality defaults and automation windows per recorder.</p> */}
    <div className="settings-page__form-grid">
      <TextInput id="recorder-profile" labelText="Default profile" placeholder="HD-Primary" />
      <TextInput id="recorder-buffer" labelText="Pre-roll buffer (sec)" placeholder="10" />
    </div>
  </>
);

export default RecorderSettings;
